/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { RecoveryForm } from 'components/modules';
import { routes } from 'const';
import { PortalFormWrapper, PoweredBy, PortalWelcomeText } from 'components/elements';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function PasswordRecovery() {
  const classes = useStyles();
  const { t } = useTranslation('labels');
  const [isEmailCorrect, setIsEmailCorrect] = useState(false);

  return (
    <>
      <PortalFormWrapper>
        <>
          <PortalWelcomeText isForm>
            {!isEmailCorrect && (
              <Typography className={classes.formSubtitle} variant="caption" component="h2">
                {t('please_enter_your_account_email_to_receive_a_link_allowing_you_to_reset_your_password')}
              </Typography>
            )}
          </PortalWelcomeText>
          {isEmailCorrect ? (
            <div className={classes.correctEmailText}>
              <Typography style={{ fontWeight: 'bold' }} className={classes.caption} variant="h6" component="h6">
                {t('we_ve_emailed_you_instructions_for_resetting_your_password')}
              </Typography>
              <Typography className={classes.caption} variant="h6" component="span">
                {t('if_you_havent_received_one_yet_please_make_sure_you_entered_the_correct_email_address_and_check_your_spam_folder')}
              </Typography>
            </div>
          ) : (
            <RecoveryForm onSubmit={() => setIsEmailCorrect(true)} />
          )}
          <Link className={classes.loginLink} to={routes.login}>
            {t('back_to_login')}
          </Link>
        </>
      </PortalFormWrapper>
      <PoweredBy />
    </>
  );
}

export default PasswordRecovery;
